function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeadlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "384pt",
    height: "384pt",
    viewBox: "0 0 384 384",
    className: "iconadda",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Deadline_free_icon_dZRlZBL-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -0.000635938 -0.00212863 L -0.000635938 -248.679955 C -0.000635938 -260.560199 -9.630873 -270.190436 -21.516325 -270.190436 L -351.548561 -270.190436 C -363.428805 -270.190436 -373.064251 -260.560199 -373.064251 -248.679955 L -373.064251 205.363068 C -373.064251 217.243312 -363.434014 226.878758 -351.548561 226.878758 L -21.516325 226.878758 C -9.630873 226.878758 -0.000635938 217.248521 -0.000635938 205.368277 L -0.000635938 34.034431 ",
    transform: "matrix(0.749998,0,0,-0.749998,331.895008,175.760122)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Deadline_free_icon_dZRlZBL-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 0.000873067 -0.00221461 L -23.973157 -0.00221461 C -30.0513 -0.00221461 -34.97319 4.924883 -34.97319 11.003027 L -34.97319 391.446872 C -34.97319 397.525015 -30.046092 402.446905 -23.973157 402.446905 L 258.397479 402.446905 C 264.475622 402.446905 269.397511 397.519807 269.397511 391.446872 L 269.40272 11.003027 C 269.40272 4.924883 264.475622 -0.00221461 258.397479 -0.00221461 L 35.105145 -0.00221461 ",
    transform: "matrix(0.749998,0,0,-0.749998,104.089189,333.287402)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Deadline_free_icon_dZRlZBL-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -0.00135995 0.000778852 L 27.847682 0.000778852 ",
    transform: "matrix(0.749998,0,0,-0.749998,181.555707,355.844334)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Deadline_free_icon_dZRlZBL-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 0.000803582 -0.00228311 C 0.000803582 -9.882521 -8.009637 -17.892962 -17.889875 -17.892962 C -27.770113 -17.892962 -35.780553 -9.882521 -35.780553 -0.00228311 C -35.780553 9.877955 -27.770113 17.888395 -17.889875 17.888395 C -8.009637 17.893604 0.000803582 9.883163 0.000803582 -0.00228311 Z M 0.000803582 -0.00228311 ",
    transform: "matrix(0.749998,0,0,-0.749998,128.479866,109.955319)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Deadline_free_icon_dZRlZBL-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -0.00105195 0.00143 L 170.759875 0.00143 ",
    transform: "matrix(0.749998,0,0,-0.749998,154.282039,98.301854)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Deadline_free_icon_dZRlZBL-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -0.00105195 -0.000787868 L 170.759875 -0.000787868 ",
    transform: "matrix(0.749998,0,0,-0.749998,154.282039,121.608784)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Deadline_free_icon_dZRlZBL-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 0.000803582 0.00255338 C 0.000803582 -9.877684 -8.009637 -17.888125 -17.889875 -17.888125 C -27.770113 -17.888125 -35.780553 -9.877684 -35.780553 0.00255338 C -35.780553 9.882791 -27.770113 17.893232 -17.889875 17.893232 C -8.009637 17.893232 0.000803582 9.882791 0.000803582 0.00255338 Z M 0.000803582 0.00255338 ",
    transform: "matrix(0.749998,0,0,-0.749998,128.479866,182.369103)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Deadline_free_icon_dZRlZBL-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -0.00105195 0.00105814 L 170.759875 0.00105814 ",
    transform: "matrix(0.749998,0,0,-0.749998,154.282039,170.715637)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Deadline_free_icon_dZRlZBL-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -0.00105195 -0.00115973 L 170.759875 -0.00115973 ",
    transform: "matrix(0.749998,0,0,-0.749998,154.282039,194.022568)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Deadline_free_icon_dZRlZBL-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 0.000803582 0.00218152 C 0.000803582 -9.878056 -8.009637 -17.888497 -17.889875 -17.888497 C -27.770113 -17.888497 -35.780553 -9.878056 -35.780553 0.00218152 C -35.780553 9.882419 -27.770113 17.89286 -17.889875 17.89286 C -8.009637 17.89286 0.000803582 9.882419 0.000803582 0.00218152 Z M 0.000803582 0.00218152 ",
    transform: "matrix(0.749998,0,0,-0.749998,128.479866,254.782886)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Deadline_free_icon_dZRlZBL-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -0.00105195 0.00168628 L 170.759875 0.00168628 ",
    transform: "matrix(0.749998,0,0,-0.749998,154.282039,243.130171)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Deadline_free_icon_dZRlZBL-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -0.00105195 -0.00153159 L 170.759875 -0.00153159 ",
    transform: "matrix(0.749998,0,0,-0.749998,154.282039,266.436351)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadlineIcon);
export default __webpack_public_path__ + "static/media/DeadlineIcon.6345a85a938a72e2db9856b3d852c1ef.svg";
export { ForwardRef as ReactComponent };